import script from "./overview.vue?vue&type=script&lang=ts&setup=true"
export * from "./overview.vue?vue&type=script&lang=ts&setup=true"

import "./overview.vue?vue&type=style&index=0&id=3e48cd5f&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3e48cd5f"]])

export default __exports__